import Select from './Select.vue'

export default Select

export interface SelectOption {
  value: string | null
  text: string
  disabled?: boolean
}
